import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, Timestamp } from "typeorm";

@Entity('attendance_log')
export class AttendanceLogEntity {

    @PrimaryGeneratedColumn('increment', {
        name: 'attendace_log_id'
    })
    attendaceLogId: number;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'log_date'
    })
    logDate: string;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_code'
    })
    employeeCode: string;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'employee_name'
    })
    employeeName: string;

    @Column("varchar", {
        nullable: true,
        name: "device_code"
    })
    deviceCode: string;

    @Column({
        name: 'download_date'
    })
    downloadDate: string;

    @Column({
        name: 'verify_mode'
    })
    verifyMode: string;

    @Column({
        name: 'direction'
    })
    direction: string;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column({
        default: false,
        name: "status"
    })
    status: boolean;

}
